import { User } from 'lucide-react';
import { Avatar, AvatarImage, AvatarFallback } from '@/components/ui/avatar';

// Import default avatars
import defaultAvatar1 from '@/assets/avatars/default-1.png';
import defaultAvatar2 from '@/assets/avatars/default-2.png';
import defaultAvatar3 from '@/assets/avatars/default-3.png';
import defaultAvatar4 from '@/assets/avatars/default-4.png';
import defaultAvatar5 from '@/assets/avatars/default-5.png';
import defaultAvatar6 from '@/assets/avatars/default-6.png';
import defaultAvatar7 from '@/assets/avatars/default-7.png';
import defaultAvatar8 from '@/assets/avatars/default-8.png';
import defaultAvatar9 from '@/assets/avatars/default-9.png';
import defaultAvatar10 from '@/assets/avatars/default-10.png';

const DEFAULT_AVATARS = [
  defaultAvatar1,
  defaultAvatar2,
  defaultAvatar3,
  defaultAvatar4,
  defaultAvatar5,
  defaultAvatar6,
  defaultAvatar7,
  defaultAvatar8,
  defaultAvatar9,
  defaultAvatar10,
];

interface ForumAvatarProps {
  avatarUrl?: string | null;
  defaultAvatar?: number | null;
  name: string;
  size?: 'sm' | 'md' | 'lg';
  onClick?: () => void;
}

export function ForumAvatar({ avatarUrl, defaultAvatar, name, size = 'sm', onClick }: ForumAvatarProps) {
  const sizeClasses = size === 'sm' ? 'h-6 w-6' : size === 'md' ? 'h-8 w-8' : 'h-11 w-11';
  const iconSize = size === 'sm' ? 'h-3 w-3' : size === 'md' ? 'h-4 w-4' : 'h-5 w-5';
  
  // Determine the image source
  let imageSrc: string | null = null;
  
  if (avatarUrl) {
    imageSrc = avatarUrl;
  } else if (defaultAvatar !== null && defaultAvatar !== undefined && defaultAvatar >= 1 && defaultAvatar <= 10) {
    imageSrc = DEFAULT_AVATARS[defaultAvatar - 1];
  }

  return (
    <Avatar 
      className={`${sizeClasses} ${onClick ? 'cursor-pointer hover:ring-2 hover:ring-primary/50 transition-all' : ''}`}
      onClick={onClick}
    >
      {imageSrc ? (
        <AvatarImage src={imageSrc} alt={name} className="object-cover" />
      ) : null}
      <AvatarFallback className="bg-muted text-muted-foreground">
        <User className={iconSize} />
      </AvatarFallback>
    </Avatar>
  );
}
